/**
 * Directive for match two password fields
 *
 * @ngInject
 */
export default () => {
    return {
        require: 'ngModel',
        link: function (scope, elem, attrs, ctrl) {
            var firstPassword = '#' + attrs.passwordMatch;
            elem.add(firstPassword).on('keyup', function () {
                scope.$apply(function () {
                    let repeat = $(firstPassword);
                    var v = elem.val() === repeat.val();
                    ctrl.$setValidity('passwordMatch', v);
                });
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/misc/directives/passwordMatch.directive.js